import React, { useState } from "react"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import "./new.scss"
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload"

export const New = ({ title, inputs }) => {
	const [imgFile, setFile] = useState("")
	return (
		<div className="new">
			<Sidebar />
			<div className="newContainer">
				<Navbar />
				<div className="top">
					<h1 className="title">{title}</h1>
				</div>
				<div className="bottom">
					<div className="left">
						<img
							src={ imgFile? URL.createObjectURL(imgFile) : "https://images.pexels.com/photos/4355346/pexels-photo-4355346.jpeg?cs=srgb&dl=pexels-murat-esibatir-4355346.jpg&fm=jpg"}
							alt="avatar"
							className="avatar"
						/>
					</div>
					<div className="right">
						<form action="" method="post">
							<div className="formInput">
								<label htmlFor="file">
									Image: <DriveFolderUploadIcon className="icon" />
								</label>
								<input type="file" id="file" onChange={e => setFile(e.target.files[0])} style={{ display: "none" }} />
							</div>
							{inputs.map((input) => (
								<div className="formInput" key={input.id}>
									<label>{input.label}</label>
									<input type={input.type} placeholder={input.placeholder} />
								</div>
							))}

							<button>Send</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
